<template>
    <div v-if="portal" v-route-title="'配置'+portal.name">
        <div class="main_left">
            <div class="menu_left22" style="width: 100%;">
                <h5 class="menu_title">{{portal.name}}<i @click="addPage" class="el-icon-circle-plus" style="float: right;"></i></h5>
                <div class="project-list" v-if="pages">
                    <el-tree node-key="id" :current-node-key="currentPage?currentPage.data.id:null" highlight-current
                             class="yq-portal-tree" :data="pages" :props="treeProps" default-expand-all
                             @current-change="onCurrentChange" draggable :allow-drop="allowDrop"
                             @node-drop="onNodeDrop">
                    <span class="yq-portal-tree-node" slot-scope="{ node, data }">
                        <span class="yq-portal-tree-node-left">
                            <i :class="{
                            'el-icon-folder-opened': data.type==='folder' && node.expanded,
                            'el-icon-folder': data.type==='folder' && !node.expanded,
                            'el-icon-tickets': data.type!=='folder'
                            }"></i>
                            <span>{{ node.label }}</span>
                        </span>
                        <el-dropdown trigger="click" @click.native.stop  @command="handlePageCommand">
                          <span class="el-dropdown-link">
                              <i class="el-icon-more"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :command="{op:'u', data: data}">修改</el-dropdown-item>
                              <el-dropdown-item :command="{op:'d', data: data}">删除</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                    </span>
                    </el-tree>
                </div>
            </div>
        </div>
        <div class="main_right33">
            <component v-if="currentPage" ref="page" :is="currentPage.type.config || currentPage.type.component"
                       :id="currentPage.data.id" :is-template="false"></component>
        </div>
        <el-dialog v-if="pageModel" :title="pageModel.id?'修改页面':'添加页面'" :visible.sync="pageDialogVisible" width="500px">
            <el-form ref="pageForm" :model="pageModel" label-width="100px" :rules="pageRules">
                <el-form-item label="页面名称" prop="name">
                    <el-input v-model="pageModel.name"></el-input>
                </el-form-item>
                <el-form-item label="上级页面" prop="parentPage" v-if="!pageModel.id">
                    <el-select v-model="pageModel.parentPage" clearable value-key="id" style="width: 100%">
                        <el-option v-for="page in navPages" :key="page.id" :label="page.name" :value="page"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="页面类型" prop="type" v-if="!pageModel.id">
                    <el-select v-model="pageModel.type" style="width: 100%">
                        <el-option v-if="!pageModel.parentPage" value="folder" label="导航文件夹"></el-option>
                        <el-option v-for="type in pageTypes" :key="type.type" :value="type.type" :label="type.typeName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建方式" prop="createType" v-if="!pageModel.id && pageModel.type!=='folder'">
                    <el-select v-model="pageModel.createType" style="width: 100%">
                        <el-option value="default" label="默认页面"></el-option>
                        <el-option value="template" label="根据模板创建"></el-option>
                        <el-option value="copy" label="复制其他页面"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="页面模板" prop="template" v-if="pageModel.createType === 'template' && pageModel.type">
                    <template-select v-model="pageModel.template" :page-type="pageModel.type"></template-select>
                </el-form-item>
                <el-form-item label="复制页面" prop="copyFrom" v-if="pageModel.createType === 'copy' && pageModel.type">
                    <page-select v-model="pageModel.copyFrom" :page-type="pageModel.type"></page-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pageDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitPageForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import portalService from '../service/portal'
    import pageService from '../service/page'
    import pageTypeService from '../service/page-type'
    import TemplateSelect from '../components/common/TemplateSelect'
    import PageSelect from '../components/common/PageSelect'

    export default {
        name: "PortalConfig",
        props: ['id'],
        components: {TemplateSelect, PageSelect},
        data(){
            return {
                portal: null,
                pages: null,
                treeProps: {
                    children: 'children',
                    label: 'name'
                },
                pageDialogVisible: false,
                pageModel: null,
                pageTypes: [],
                currentPage: null
            }
        },
        computed:{
            navPages(){
                return this.pages.filter(page => page.type === 'folder')
            },
            pageRules(){
                const rules = {
                    name: [
                        {required: true, message: '请输入页面名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请选择页面类型', trigger: 'blur'}
                    ]
                }
                if(!this.pageModel.id){
                    rules.createType = [
                        {required: true, message: '请选择创建方式', trigger: 'blur'}
                    ]
                    if(this.pageModel.createType === 'template' && this.pageModel.type){
                        rules.template = [
                            {required: true, message: '请选择页面模板', trigger: 'blur'}
                        ]
                    }
                    if(this.pageModel.createType === 'copy' && this.pageModel.type){
                        rules.copyFrom = [
                            {required: true, message: '请选择复制页面', trigger: 'blur'}
                        ]
                    }
                }
                return rules
            }
        },
        created(){
            this.init()
        },
        methods: {
            init(){
                pageTypeService.getAssignedPageTypes().then(pageTypes => this.pageTypes = pageTypes)
                portalService.getPortal(this.id).then(response=>{
                    this.portal = response.data
                    pageService.listPages({
                        portalId: this.id,
                        page: 0,
                        size: 1000
                    }).then(response => {
                        const pages = response.data.content
                        this.pages = portalService.buildPortalPageTree(pages)
                        const stack= [...this.pages]
                        while(stack.length>0){
                            const page = stack.shift()
                            if(page.type !== 'folder'){
                                this.currentPage = {
                                    data: page,
                                    type: pageTypeService.getPageType(page.type)
                                }
                                break
                            }
                            if(page.children){
                                stack.splice(0,0,...page.children)
                            }
                        }
                    })
                }).catch(()=>{
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                })
            },
            addPage(){
                this.pageModel = {
                    name: null,
                    type: null,
                    parentPage: null,
                    createType: null,
                    template: null,
                    copyFrom: null
                }
                this.pageDialogVisible = true
            },
            submitPageForm() {
                this.$refs.pageForm.validate().then(() => {
                    if (this.pageModel.id) {
                        const data = {
                            id: this.pageModel.id,
                            name: this.pageModel.name,
                            config: this.pageModel.config,
                            parent: this.pageModel.parent,
                            prevPageId: this.pageModel.prevPageId
                        }
                        pageService.updatePage(data).then(() => {
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                            this.pageDialogVisible = false
                            this.pageModel.page.name = this.pageModel.name
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                            throw error
                        })
                    } else {
                        const data = {
                            name: this.pageModel.name,
                            type: this.pageModel.type,
                            parent: this.pageModel.parentPage?this.pageModel.parentPage.id:null,
                            portalId: this.id
                        }
                        let parent = this.pageModel.parentPage
                        let prevPage
                        if(this.pageModel.parentPage){
                            data.parent = this.pageModel.parentPage.id
                            const children = this.pageModel.parentPage.children
                            prevPage = children ? children[children.length-1] : null
                            data.prevPageId = prevPage?prevPage.id:null
                        }else{
                            data.parent = null
                            prevPage = this.pages?this.pages[this.pages.length-1]:null
                            data.prevPageId = prevPage?prevPage.id:null
                        }
                        const params = {
                            templateId: this.pageModel.createType === 'template' ? this.pageModel.template.id : null,
                            copyFrom: this.pageModel.createType === 'copy' ? this.pageModel.copyFrom.id : null
                        }
                        pageService.addPage(params, data).then(response => {
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                            this.pageDialogVisible = false
                            data.id = response.data.id
                            data.parentPage = parent
                            data.prevPage = prevPage
                            if(parent){
                                parent.children.push(data)
                            }else{
                                this.pages.push(data)
                            }
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                            throw error
                        })
                    }
                }).catch(()=>{})
            },
            handlePageCommand(command){
                if(command.op==='u'){
                    this.pageModel = {
                        id: command.data.id,
                        name: command.data.name,
                        config: command.data.config,
                        parent: command.data.parent,
                        prevPageId: command.data.prevPageId,
                        page: command.data
                    }
                    this.pageDialogVisible = true
                } else {
                    this.$confirm('此操作将永久删除该页面, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        pageService.deletePage(command.data.id).then(()=>{
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            const children = command.data.parentPage ? command.data.parentPage.children : this.pages
                            const idx = children.indexOf(command.data)
                            if (idx < children.length - 1) {
                                const nextPage = children[idx+1]
                                nextPage.prevPage = command.data.prevPage
                                nextPage.prevPageId = command.data.prevPageId
                            }
                            children.splice(idx, 1)
                        }).catch(()=>{
                            this.$message({
                                type: 'error',
                                message: '删除失败!'
                            })
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }
            },
            async onCurrentChange(data){
                if(data.type === 'folder'){
                    return
                }
                if(this.currentPage && this.currentPage.data === data){
                    return
                }
                if(this.$refs.page && this.$refs.page.isDirty && this.$refs.page.isDirty()){
                    await new Promise((resolve, reject) => {
                        this.$confirm('当前页面已被修改, 是否保存?', '提示', {
                            confirmButtonText: '保存',
                            cancelButtonText: '不保存',
                            type: 'warning'
                        }).then(() => {
                            this.$refs.page.savePageConfig().then(resolve).catch(reject)
                        }).catch(() => {
                            resolve()
                        })
                    })
                }
                this.currentPage = {
                    data: data,
                    type: pageTypeService.getPageType(data.type)
                }
            },
            allowDrop(draggingNode, dropNode, type) {
                if (dropNode.data.type === 'folder') {
                    return type !== 'inner' || draggingNode.data.type !== 'folder'
                } else if (draggingNode.data.type === 'folder') {
                    return type !== 'inner' && dropNode.level === 1
                } else {
                    return type !== 'inner'
                }
            },
            onNodeDrop(draggingNode, dropNode, dropType){
                const draggingPage = draggingNode.data
                const data = {
                    id: draggingPage.id,
                    name: draggingPage.name,
                    config: draggingPage.config
                }
                if(dropType === 'inner'){
                    data.parent = dropNode.data.id
                    if (dropNode.data.children.length>1){
                        data.prevPageId = dropNode.data.children[dropNode.data.children.length-2].id
                    }else{
                        data.prevPageId = null
                    }
                }else if(dropType === 'after'){
                    data.parent = dropNode.data.parent
                    data.prevPageId = dropNode.data.id
                }else{
                    data.parent = dropNode.data.parent
                    data.prevPageId = dropNode.data.prevPageId
                }
                pageService.updatePage(data).then(()=>{
                    // 更新本地状态
                    const stack = [{children:this.pages}]
                    while(stack.length>0){
                        const page = stack.shift()
                        if (page.children && page.children.length>0){
                            page.children.forEach((childPage,index) => {
                                if(page.id){
                                    childPage.parent = page.id
                                    childPage.parentPage = page
                                }else{
                                    childPage.parent = null
                                    childPage.parentPage = null
                                }
                                if(index>0){
                                    childPage.prevPageId = page.children[index-1].id
                                    childPage.prevPage = page.children[index-1]
                                }else{
                                    childPage.prevPageId = null
                                    childPage.prevPage = null
                                }
                                stack.push(childPage)
                            })
                        }
                    }
                }).catch(error=>{
                    this.$message({
                        type: 'error',
                        message: '拖拽失败!'
                    })
                    this.init()
                    throw error
                })

            }
        }
    }
</script>

<style scoped>
</style>
